"use strict";
/**
 * @module FetchRequest
 */
Object.defineProperty(exports, "__esModule", { value: true });
var topic_specification_1 = require("../../../topics/topic-specification");
/**
 * Implementation of the TopicResult interface
 */
var TopicResultImpl = /** @class */ (function () {
    /**
     * Create a new TopicResultImpl instance
     *
     * @param path        the topic path
     * @param type        the topic type
     * @param value       the value if one was requested
     * @param properties  the topic properties
     */
    function TopicResultImpl(path, type, value, properties) {
        this.mPath = path;
        this.mType = type;
        this.mValue = value;
        this.mProperties = properties;
    }
    /**
     * @inheritdoc
     */
    TopicResultImpl.prototype.path = function () {
        return this.mPath;
    };
    /**
     * @inheritdoc
     */
    TopicResultImpl.prototype.type = function () {
        return this.mType;
    };
    /**
     * @inheritdoc
     */
    TopicResultImpl.prototype.value = function () {
        return this.mValue;
    };
    /**
     * @inheritdoc
     */
    TopicResultImpl.prototype.specification = function () {
        return new topic_specification_1.TopicSpecification(this.mType, this.mProperties);
    };
    return TopicResultImpl;
}());
exports.TopicResultImpl = TopicResultImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/features/topics/topic-result.js
// module id = 1478
// module chunks = 1